import styles from "./toolbox-components.module.css";
import { PointIconName } from "PosterEditor/model/poster-types";
import { PointIcon } from "PosterEditor/common-components/point-icon";
import classNames from "classnames";

interface ToolboxComponentPointIconGridProps {
  selectedIcon: PointIconName | undefined;
  onSelectIcon: (icon: PointIconName) => void;
}

const iconsToShow: PointIconName[] = [
  "DOT",
  "PIN_ONE",
  "PIN_TWO",
  "HOME",
  "MAN_WALKING",
  "RAIN_CLOUD",
  "THUNDER_CLOUD",
  "SNOW_CLOUD",
  "WIND",
  "TEMPERATURE_UP",
  "TEMPERATURE_DOWN",
  "SUN",
  "FACE_1",
  "FACE_2",
  "FACE_3",
  "FACE_4",
  "FACE_5",
  "FACE_6",
  "FACE_7",
  "SKULL",
  "WINE",
  "PINT",
];

export const ToolboxComponentPointIconGrid = (
  props: ToolboxComponentPointIconGridProps
) => {
  const interactiveColor = getComputedStyle(
    document.documentElement
  ).getPropertyValue("--color-interactive");

  const textColor = getComputedStyle(document.documentElement).getPropertyValue(
    "--color-text-primary"
  );

  return (
    <div className={styles.iconGrid}>
      {iconsToShow.map((iconName, index) => {
        const isSelected = iconName === props.selectedIcon;
        return (
          <div
            className={classNames(styles.singleIconContainer, {
              [styles.selected]: isSelected,
            })}
          >
            <div
              key={index}
              className={styles.iconGridIcon}
              onClick={() => {
                props.onSelectIcon(iconName);
              }}
            >
              <PointIcon
                iconName={iconName}
                color={isSelected ? textColor : interactiveColor}
                size={30}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
